import React, { useState } from 'react';

import { IContactAccountItemProps } from './~types/ContactAccountItemProps';

import './ContactAccountItem.css';
import { Button, DropdownItem, Input } from 'reactstrap';
import { IContactAccountListProps } from '../~types/ContactAccountListProps';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

const ContactAccountItem = (props: IContactAccountItemProps) => {
    const [externalId, setId] = useState(props.account.externalId);
    const [login, setLogin] = useState(props.account.login);
    const [source, setSource] = useState(props.account.source);
    const [isEditing, setEditing] = useState(false);
    const [isCreating, setCreating] = useState(props.isCreating);
    const [isDropdownListVisible, setDropdownListVisible] = useState(false);
    React.useEffect(() => {
        const rootElement = document.getElementById("root");
        rootElement?.removeEventListener("click", _onClickRoot);
        rootElement?.addEventListener("click", _onClickRoot);

        return () => {
            rootElement?.removeEventListener("click", _onClickRoot);
        }
    }, []);

    const accountTypesOption :(JSX.Element[]) = [];

    const getAccountTypes = () => {
        if (accountTypesOption.length >= props.accountTypes.length)
            return;
        for (let i = 0; i < props.accountTypes.length; i++) {
            if (props.accountTypes[i] === null)
                continue;
            accountTypesOption.push(<DropdownItem className="contact-account-item__type-item" onClick={() => setSource(props.accountTypes[i])}> {props.accountTypes[i]}</DropdownItem>);
        }
    }

    getAccountTypes();

    const _onClickRoot = (event: MouseEvent) => {
        const targetElement = event.target as Element;
        const accountTypeElement = document.getElementsByClassName('contact-account-item__type-input')[0];
        if (accountTypeElement !== undefined && targetElement !== undefined) {
            if (targetElement.className + ' form-select' !== accountTypeElement?.className) {
                setDropdownListVisible(false);
            }
        }
    }

    const getLinkToBilling = (): string => {
        return "https://tdadmin.unet.by/account/" + login;
    }

    const getLinkToAmo = (): string => {
        return "https://unetby.amocrm.ru/leads/detail/" + externalId;
    }
    
    const getLink = () => {
        switch (source) {
            case "Amo": {
                return getLinkToAmo();
            }
            case "Billing": {
                return getLinkToBilling();
            }
        }
    }

    return (
        <tr className="contact-account-item__table-row">
            <td>
                {(isEditing || isCreating) &&
                    <Input
                        className="contact-account-item__id-input"
                        value={externalId}
                        onChange={(event) => setId(event.target.value)} />
                }
                {(!isEditing && !isCreating) && 
                    <a
                        className="contact-account-item__id"
                        href={getLink()}
                        target="_blank">
                        {externalId}
                    </a>
                }
            </td>
            <td>
                {(isEditing || isCreating) && 
                    <Input
                        className="contact-account-item__login-input"
                        value={login}
                        onChange={(event) => setLogin(event.target.value)}/>
                }
                {(!isEditing && !isCreating) && 
                    <div className="contact-account-item__login">
                        {login}
                    </div>
                }
            </td>
            <td>
                {(isEditing || isCreating) &&
                    <div className="contact-account-item__type-container">
                        <Dropdown
                            isOpen={isDropdownListVisible}
                            toggle={() => void 0}
                            direction="down">

                            <DropdownToggle className="contact-account-item__type-toggle">
                            </DropdownToggle>
                            {isDropdownListVisible &&
                                <DropdownMenu className="contact-account-item__type-menu">
                                    {accountTypesOption}
                                </DropdownMenu>
                            }
                        </Dropdown>
                    <input
                            id="contact-account-item__type-input"
                            className="contact-account-item__type-input"
                            value={source}
                            onChange={(event) => setSource(event.target.value)}
                            onClick={() => setDropdownListVisible(true)}
                            autoComplete="off"
                            onKeyDown={() => {
                                setDropdownListVisible(true);
                                getAccountTypes();
                            }}/>
                    </div>
                }
                {(!isEditing && !isCreating) && 
                    <div className="contact-account-item__type">
                        {source}
                    </div>
                }
            </td>
            <td className="contact-account-item__actions">
                {(!isEditing && !isCreating) && 
                    <React.Fragment>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-edit"
                            onClick={() => {
                                setEditing(true);
                            }}>
                                <i className="material-icons">edit</i>
                        </Button>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-delete"
                            onClick={() => props.deleteAccount(props.account.id)}>
                                <i className="material-icons">delete_forever</i>
                        </Button>
                </React.Fragment>}
                {(isEditing || isCreating) &&
                    <React.Fragment>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-save"
                            disabled={!Boolean(externalId?.trim()?.length) || 
                                      !Boolean(login?.trim()?.length) || 
                                      !Boolean(source?.trim()?.length)}
                            onClick={() => {
                                var isSuccessSave = props.saveAccount({
                                    ...props.account,
                                    externalId,
                                    login,
                                    source
                                });
                                if (login && externalId && source && isSuccessSave) {
                                    setEditing(false);
                                    setCreating(false);
                                }                                
                            }}>
                                <i className="material-icons">save</i>
                        </Button>
                        <Button
                            className="contact-account-item__btn contact-account-item__btn-replay"
                            onClick={() => {
                                if (isEditing) {
                                    setId(props.account.externalId);
                                    setLogin(props.account.login);
                                    setSource(props.account.source);
                                    setEditing(false);
                                    setCreating(false);
                                } else {
                                    props.deleteAccount(props.account.id);
                                }                                
                            }}>
                                <i className="material-icons">replay</i>
                        </Button>
                    </React.Fragment>
                }
            </td>
        </tr>
    )
}

export default ContactAccountItem;